export const sessionStorageVariables = {
  VALUE_FORMAT: 'ccs/projections/VALUE_FORMAT',
};